var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-kn",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kn-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-80.1 0h682.7v512H-80.1z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#kn-a)",
    transform: "translate(75.1)scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe900",
    d: "M-107.8.2h737.6v511.3h-737.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35a100",
    d: "m-108.2.2.8 368.6L466.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c70000",
    d: "m630.7 511.5-1.4-383.2-579 383.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m-107.9 396.6.5 115.4 125.3-.2 611.7-410.1L629 1.4 505.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m380.4 156.6-9.8-42.2 33.3 27 38-24.6-17.4 41.3 33.4 27-44.2-1.5-17.3 41.3-9.9-42.2-44.1-1.5zm-275.2 179-9.9-42.3 33.3 27 38-24.6-17.4 41.3 33.4 27-44.1-1.5-17.4 41.3-9.8-42.2-44.1-1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKn);
export default __webpack_public_path__ + "static/media/kn.650b92794fb6826cea932164970c097e.svg";
export { ForwardRef as ReactComponent };